<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات دسته بندی فعالیت"
        >
          <b-form
            ref="activitycategoryform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    cols="12"
                    class="mb-1"
                  >
                    <fm-file-select
                      v-model="Form.Image"
                      label="عکس"
                      :entity="1"
                    />
                  </b-col>

                  <b-col md="8">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="ترتیب"
                      label-for="Sort"
                    >
                      <b-form-input
                        id="Sort"
                        v-model="Form.Sort"
                        name="Sort"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-row
                      v-for="(item, index) in Form.ActivityCategoryLanguage"
                      :key="index"
                    >

                      <b-col cols="12">
                        <hr>
                      </b-col>

                      <b-col md="5">
                        <b-form-group>
                          <label>زبان:</label>
                          <z-language
                            v-model="item.Language"
                            :unselectable="Form.ActivityCategoryLanguage.map(x => x.Language)"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="5">
                        <b-form-group
                          label="عنوان"
                        >
                          <b-form-input
                            v-model="item.Title"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: flex-end;"
                      >
                        <template v-if="ActivityCategoryLanguageRemoveId !== index">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeActivityCategoryLanguage(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-

                            icon rounded-circle"
                            variant="outline-primary"
                            @click="cancelActivityCategoryLanguage"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle ml-1"
                            variant="outline-primary"
                            @click="confirmActivityCategoryLanguage"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>

                    </b-row>
                  </b-col>

                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addActivityCategoryLanguage"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import FmFileSelect from '@/views/menu/file-manager/components/fmFileSelect.vue'

export default {
  name: 'ActivityCategoryDetails',
  components: {
    FmFileSelect,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        ActivityCategoryLanguage: [],
      },
      ActivityCategoryLanguageRemoveId: null,
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addActivityCategoryLanguage()
    }
  },
  methods: {
    save() {
      let url = this.$api.activitycategory.add
      if (this.$route.params.id) {
        url = this.$api.activitycategory.update
      }

      const payload = {
        ...this.Form,
        ActivityCategoryLanguage: (this.Form.ActivityCategoryLanguage || [])
          .filter(item => typeof item.Language === 'number'),
      }

      this.loading = true
      this.$http.post(url, payload)
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.activitycategory.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    addActivityCategoryLanguage() {
      this.Form.ActivityCategoryLanguage.push({ Title: null, Language: null })
    },
    removeActivityCategoryLanguage(index) {
      this.ActivityCategoryLanguageRemoveId = index
    },
    confirmActivityCategoryLanguage() {
      this.Form.ActivityCategoryLanguage.splice(this.ActivityCategoryLanguageRemoveId, 1)
      this.ActivityCategoryLanguageRemoveId = null
    },
    cancelActivityCategoryLanguage() {
      this.ActivityCategoryLanguageRemoveId = null
    },
  },
}
</script>

<style scoped>
</style>
